import React from 'react';
import Heading from '@hubins/components/Heading';
import FormDocument from '../FormDocument/FormDocument';
import './index.scss'
import ExpandableContent from '../ExpandableContent';

type Props = {
  title: string;
  files: any[];
}

const FormDocuments = ({title, files}: Props) => {
  return (
    <div className='form-documents'>
      <Heading size="4" className="s-bottom-l">
        {title}
      </Heading>
      <ExpandableContent label="Dokument">
        <div className='form-documents__list'>
          {files.map((file: any) => (
            <div className='form-documents__item'>
              <FormDocument
                key={file.id}
                id={file.id}
                title={file.name}
              />
            </div>
          ))}
        </div>
      </ExpandableContent>
    </div>
  );
};

export default FormDocuments;